import { PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
var PaymentStatusPipe = /** @class */ (function () {
    function PaymentStatusPipe(translateService) {
        this.translateService = translateService;
    }
    PaymentStatusPipe.prototype.transform = function (statusName) {
        if (statusName) {
            return this.translateService.instant("MAINTENANCES.PAYMENTS.STATUS_OPTIONS." + statusName.toString().toUpperCase());
        }
        return null;
    };
    return PaymentStatusPipe;
}());
export { PaymentStatusPipe };
